import LvFanEvent from './LvFanEvent';

const LvFanEventKo = () => {
    return (
        <LvFanEvent
            currentPath="/lv4-ko"
            // songGuideTitle="Hush 떼창 이벤트 가이드"
            sloganGuideTitle="포토타임 구호 가이드"
            eventImage="/fan-event-info-ko.png"
        />
    );
};

export default LvFanEventKo;
